import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../constants/msgConstants'
import transformacaoManager from '../../services/api/transformacao/transformacaoManager'
import { RegraTransformacao } from '../../types/transformacaoApiTypes'
import { useLoading } from '../../hooks/useLoading'

export function regraTransformacaoIO() {
  const { parceiroId, regraId } = useParams<{ parceiroId: string; regraId: string }>()
  const [regraTransformacaoEditar, setRegraTransformacaoEditar] = useState<RegraTransformacao>()
  const { showLoading, hideLoading } = useLoading()

  useEffect(() => {
    const buscarRegraAssociacao = async () => {
      if (parceiroId && regraId) {
        showLoading()
        transformacaoManager
          .buscarRegra(parceiroId, regraId)
          .then((response: RegraTransformacao) => {
            setRegraTransformacaoEditar(response)
          })
          .catch(() => toast.error(msgConstants.USO_GENERICO.erroBusca))
          .finally(() => hideLoading())
      }
    }

    buscarRegraAssociacao()
  }, [parceiroId, regraId, showLoading, hideLoading])

  return {
    regraTransformacaoEditar,
    regraId
  }
}

export type RegraTransformacaoIO = ReturnType<typeof regraTransformacaoIO>
